import { format as formatFns } from 'date-fns'
import { arSA, enUS } from 'date-fns/locale'
import { toGregorian } from 'hijri-converter'
import { DateSplit } from 'types/date'

const locales = { en: enUS, ar: arSA }
const enFormat = ['yyyy-MM-dd', 'yyyy/MM/dd']

export function format(date: Date | string, frmatStr: string): string | Date {
  if (!date) return ''
  const LOCALE = localStorage.getItem('Locale') ?? 'en'
  const formatStr = LOCALE === 'ar' ? frmatStr.replace(/MMM+/g, 'MMMM') : frmatStr
  let newDate = date
  try {
    if (typeof newDate === 'string') {
      newDate = new Date(date)
    }

    if (enFormat.includes(formatStr)) {
      return formatFns(newDate, formatStr)
    }

    return formatFns(newDate, formatStr, {
      locale: locales[LOCALE],
    })
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return date
}

export const getDateSplit = (fullDate: string): DateSplit => {
  const [day, month, year] = fullDate?.split('-') || []
  return {
    year,
    month,
    day,
  }
}

export const dmyToymd = (dayMonthYear: string): string => {
  const { day, month, year } = getDateSplit(dayMonthYear)
  return day && month && year ? `${year}-${month}-${day}` : dayMonthYear
}

export const isDateMatch = (d: string): boolean => {
  const dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/
  const isMatch = `${d}`.match(dateReg) !== null
  if (isMatch) {
    return true
  }
  return false
}

export const getTwoDigits = (n: number | string): string => {
  const twoDigits = `0${n}`.slice(-2)
  return twoDigits
}

export const getInt = (numString?: string): number => {
  const number = numString ? parseInt(numString, 10) : 0

  return number
}

export const HijriToGregorian = (dateString: string): string => {
  const { year, month, day } = getDateSplit(dateString)

  const { gd, gm, gy } = toGregorian(getInt(year), getInt(month), getInt(day))

  const dateFormat = `${getTwoDigits(gd)}-${getTwoDigits(gm)}-${gy}`

  return dateFormat
}
